import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";
import StripeBar from "@/components/StripeBar";

const PaymentCancel = () => (
  <main className="bg-navy min-h-[70vh] flex items-center" data-testid="payment-cancel-page">
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-20 w-full">
      <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden text-center p-8 sm:p-12">
        <StripeBar className="absolute top-0 inset-x-0 h-2.5" />
        <XCircle className="w-14 h-14 text-navy/40 mx-auto mb-6 mt-4" />
        <h1 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl text-navy mb-4">
          Checkout Canceled
        </h1>
        <p className="text-navy/70 text-base sm:text-lg leading-relaxed mb-8">
          No charge was made. Whenever you're ready, you can contribute online or by check — every contribution helps Dave reach Delaware voters.
        </p>
        <Link to="/contribute" data-testid="cancel-back-button" className="inline-flex items-center gap-2 bg-crimson hover:bg-crimson-dark text-white font-display font-extrabold uppercase tracking-wider text-lg px-8 py-3.5 rounded-full transition-colors min-h-[52px]">
          <ArrowLeft className="w-5 h-5" /> Back to Contribute
        </Link>
      </div>
    </div>
  </main>
);

export default PaymentCancel;
